import React from 'react';

function DeleteSalesRegister({ selectedRow }) {
  return (
    <div className="text-left px-2 pb-0">
      <p>
        <h6>This Sales Register will be deleted and could not be recovered!!</h6>
        <ul>
          <li><b>Customer Name:</b> {selectedRow?.CustomerName}</li>
          <li><b>Mobile Number:</b> {selectedRow?.MobileNumber}</li>
          <li><b>Sales Date:</b> {selectedRow?.SalesDate}</li>
        </ul>
      </p>
    </div>
  );
}

export default DeleteSalesRegister;